export default function riskSquareColor(metric) {
  if(metric > 0) {
    return('text-fpx-red border-fpx-red')
  } else {
    return('text-green border-green')
  }
}